import React from 'react'
import { Calendar } from 'lucide-react'

const icon = props => <Calendar size={20} {...props} />

export default icon
